/* eslint-disable no-unused-vars */
import Vue from "vue";
import Router from "vue-router";
import versionService from "@/services/VersionService";
import { subdomains, VERSION_CHECK_ERROR } from "@/common/consts";
import { getCurrentSubdomain } from "@/common/functions";
import www from "@/router/routes/subdomain.www.js";
import sentence from "@/router/routes/subdomain.sentence.js";
import thesaurus from "@/router/routes/subdomain.thesaurus.js";
import es from "@/router/routes/subdomain.es.js";
import abbreviations from "@/router/routes/subdomain.abbreviations.js";
import esl from "@/router/routes/subdomain.esl.js";
import reference from "@/router/routes/subdomain.reference.js";
import grammar from "@/router/routes/subdomain.grammar.js";
import education from "@/router/routes/subdomain.education.js";
import examples from "@/router/routes/subdomain.examples.js";
import PageNotFound from "@/pages/PageNotFound/PageNotFound.vue";
import DynamicPage from "@/pages/DynamicPage/DynamicPage.vue";
import analytics from "@/common/analytics";


Vue.use(Router);

let routes;
const subdomain = getCurrentSubdomain();

switch (subdomain) {
    case subdomains.SENTENCES:
        routes = sentence;
        break;
    case subdomains.THESAURUS:
        routes = thesaurus;
        break;
    case subdomains.ES:
        routes = es;
        break;
    case subdomains.ABBREVIATIONS:
        routes = abbreviations;
        break;
    case subdomains.ESL:
        routes = esl;
        break;
    case subdomains.REFERENCE:
        routes = reference;
        break;
    case subdomains.GRAMMAR:
        routes = grammar;
        break;
    case subdomains.EDUCATION:
        routes = education;
        break;
    case subdomains.EXAMPLES:
        routes = examples;
        break;
    default:
        routes = www;
}

const commonRoutes = [
    {
        path: "*",
        name: "PageNotFound",
        component: PageNotFound
    },
    {
        path: "/dynamic-page/",
        name: "DynamicPage",
        component: DynamicPage
    }
];

const router = new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    mode: "history",
    routes: routes.concat(commonRoutes)
});

/**
 * This is the list of words that have been released
 * in V2. They should have SPA behavior enabled
 */
const wordsListV2 = /\b(?:rebate|which|also|hope|family)\b|\bk|\bwi|\bf|\br|\ba|\bb|\bc/gi;
function isIndexPage() {
    const testIsIndexPage = /^\/index/.test(window.location.pathname) || false;
}
isIndexPage();

/**
 * Add rules to each subdomain
 */

function subdomainRules(to) {
    switch (subdomain) {
        case subdomains.ES:
            return to.path.startsWith(`/buscador-de-palabras`);
        case subdomains.SENTENCES:
            return !wordsListV2.test(to.path);
        case subdomains.ABBREVIATIONS:
            return true;
        default:
            return false;
    }
}

router.beforeEach((to, from, next) => {
    /**
     * Check if force reload is required only for production hostname.
     */

    if (
        subdomainRules(to) &&
        isIndexPage &&
        process.env.NODE_ENV === "production" &&
        from.name !== null &&
        from.path !== to.path
    ) {
        window.location.assign(to.path);
        return false;
    }
    next();
});

/** Vue Router afterEach Navigation Guard */
router.afterEach((to, from) => {
    // 0. Check if App has been updated and force reload if that's the case
    versionService.check().catch(err => {
        if (err.name === VERSION_CHECK_ERROR) {
            window.location.reload(true);
        }
    });
    if (typeof window.__PRERENDER_INJECTED === "undefined") {
        analytics.page({type:'load',path:to.fullPath,url:window.location.hostname+to.fullPath})
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js